import moment from "moment"
import "moment/locale/id"
import { toast } from "react-toastify"
import {
  instance1,
  TYPE_INSTANCE1,
  instance2,
  TYPE_INSTANCE2,
  instance3,
  TYPE_INSTANCE3,
  TYPE_INSTANCE4,
  instance4,
  TYPE_INSTANCE5,
  instance5,
  TYPE_SATU_SEHAT,
  instanceSatuSehat,
  instanceWsBPJS,
  TYPE_WS_BPJS_LIST_DOKTER,
  TYPE_INSTANCEAPPLICARES,
  instanceApplicares,
  TYPE_INSTANCEVCLAIM,
  instanceVclaim,
  TYPE_INSTANCE_MASTER_EMR,
  instancePublicMasterEMR,
  TYPE_INSTANCE_MASTER_EMR2,
  instancePublicMasterEMRV2,
  TYPE_INSTANCE_REGISTRASI_EMR_V3,
  instanceRegistrasiEMRV3,
  TYPE_INSTANCE_HRIS,
  instanceHRIS,
  TYPE_SATU_SEHAT_V2,
  instanceSatuSehatV2,
} from "App/constants"
import { getUserName } from "./cookies"
import { isNaN } from "lodash"

export const toUTCFormat = (str) => {
  // const m = moment(str).format(());
  // if (onlyDate) {
  //   m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  //   m.toISOString();
  // }
  // return m.format("YYYY-MM-DD");

  return moment(str).format()
}

export const formatUTC = (str) => {
  return moment(str).utc().format()
}

export const onlyNumberAndComma = (str) => {
  const regex = /^[0-9 _,]*$/
  if (!regex.test(str)) {
    return false
  } else {
    return true
  }
}
export const isNull = (str) => {
  if (
    str === "" ||
    str === "undefined" ||
    str === null ||
    str === undefined ||
    str === "null"
    // (Array.isArray(str) && str.length === 0) // refactored from 'str === []' due to always returned false
  ) {
    return true
  } else {
    return false
  }
}

export const tipePembayaranName = (id) => {
  if (parseInt(id) === 1) {
    return "TUNAI"
  } else if (parseInt(id) === 2) {
    return "DEBET/KREDIT"
  } else if (parseInt(id) === 3) {
    return "CLIENT/CLIENTAS"
  } else if (parseInt(id) === 4) {
    return "SALDO"
  } else {
    return "Tidak Ditemukan"
  }
}

export const tipeKartuName = (id) => {
  if (parseInt(id) === 1) {
    return "DEBET"
  } else if (parseInt(id) === 2) {
    return "KREDIT"
  } else if (parseInt(id) === 3) {
    return "Lain-Lain"
  } else {
    return "Tidak Ditemukan"
  }
}

export const convertDateToValidInput = (str) => {
  const _date = new Date(str).toLocaleDateString("id-ID", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })

  const date = _date.split("/")
  return `${date[2]}-${date[1]}-${date[0]}`
}

export const getLocalName = () => {
  const name = getUserName()
  if (name) {
    return name
  }
}

export const getAge = (dateString, dateNowCustom = null) => {
  if (isNull(dateString)) return "0 th 0 bl 0 hr"

  const now = dateNowCustom === null ? moment() : moment(dateNowCustom)
  const dob = moment(dateString)

  if (!dob.isValid()) {
    return "0 th 0 bl 0 hr"
  }

  const yearAge = now.diff(dob, "years")
  dob.add(yearAge, "years")

  const monthAge = now.diff(dob, "months")
  dob.add(monthAge, "months")

  const dateAge = now.diff(dob, "days")

  const yearString = " th"
  const monthString = " bl"
  const dayString = " hr"

  return `${yearAge}${yearString} ${monthAge}${monthString} ${dateAge}${dayString}`
}


export const getDayDuration = (from, to, withTime = false) => {
  if (withTime) {
    const onlyDateStart = moment(from).local().format("YYYY-MM-DD")
    const onlyDateEnd = moment(to).local().format("YYYY-MM-DD")
    const a = moment(onlyDateEnd).utc().local().format("YYYY-MM-DD")
    const b = moment(onlyDateStart, "YYYY-MM-DD").utc().local()
    const diffDays = b.diff(a, "days")
    return diffDays
  } else {
    const a = moment(from).utc().local().format("YYYY-MM-DD")
    const b = moment(to, "YYYY-MM-DD").utc().local()
    const diffDays = b.diff(a, "days")
    return diffDays
  }
}

export const defaultDisplayAge = (birth) => {
  const a = moment()
  const b = moment(birth, "YYYY-MM-DD")
  const years = a.diff(b, "year")
  b.add(years, "years")

  const months = a.diff(b, "months")
  b.add(months, "months")

  const days = a.diff(b, "days")

  return years + " tahun " + months + " bulan " + days + " hari"
}

export const setDateNow = (withTime = true) => {
  const date = new Date()

  const _day = date.getDate()
  const day = _day < 10 ? `0${_day}` : _day

  const _month = date.getMonth() + 1
  const month = _month < 10 ? `0${_month}` : _month

  const _hours = date.getHours()
  const hours = _hours < 10 ? `0${_hours}` : _hours

  const _minutes = date.getMinutes()
  const minutes = _minutes < 10 ? `0${_minutes}` : _minutes

  if (withTime) {
    return `${date.getFullYear()}-${month}-${day}T${hours}:${minutes}`
  } else {
    return `${date.getFullYear()}-${month}-${day}`
  }
}

export function getBase64(file, cb) {
  let reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    cb(reader.result)
  }
  reader.onerror = function (error) {
    console.log("Error: ", error)
  }
}

export const dateTimePickerToValidDate = (val, withTime = true) => {
  return withTime
    ? moment(val).local().format("YYYY-MM-DDTHH:mm")
    : moment(val).local().format("YYYY-MM-DD")
}

export const today = (withTime = false) => {
  // const intlDate = new Intl.DateTimeFormat("id-ID", {
  //   timeZone: "Asia/Jakarta",
  //   hour12: false,
  //   year: "numeric",
  //   month: "2-digit",
  //   day: "2-digit",
  //   hour: "numeric",
  //   minute: "numeric",
  // })
  //   .format(new Date(Date.now()))
  //   .split(" ");
  // const date = intlDate[0].split("/");
  // const time = intlDate[1].replaceAll(".", ":");
  // const validDate = `${date[2]}-${date[1]}-${date[0]}`;
  // return withTime ? `${validDate}T${time}` : `${validDate}`;

  return withTime
    ? moment().local().format("YYYY-MM-DDTHH:mm")
    : moment().local().format("YYYY-MM-DD")
}

export const defaultDateDisplay = (date, withTime = true, utc = true) => {
  if (isNull(date)) {
    return ""
  } else {
    if (utc) {
      const format = withTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"
      return moment(date).utc().local().format(format)
    } else {
      const format = withTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"
      return moment(date).parseZone().format(format)
    }
  }
}

export const defaultDayDisplay = (date) => {
  const format = "Do MMMM YYYY"
  return moment(date).local().locale("id").format(format)
}

export const defaultFullDayDisplay = (date, withTime = true) => {
  const format = "dddd, Do MMMM YYYY H:mm"
  return moment(date).local().locale("id").format(format)
}

export const defaultTimeDisplay = (date) => {
  return moment(date).local().locale("id").format("H:mm")
}

export const splitTime = (date) => {
  const dateSplit = date.split(/[.T]/)
  return dateSplit[0] + " " + dateSplit[1]
}

export const defaultToastError = (msg) => {
  return toast.error(msg, {
    position: toast.POSITION.TOP_CENTER,
  })
}

export const defaultToastSuccess = (msg) => {
  return toast.success(msg, {
    position: toast.POSITION.TOP_CENTER,
  })
}

export const defaultToastNotif = (msg) => {
  return toast.info(msg, {
    position: toast.POSITION.TOP_RIGHT,
  })
}

export const defaultToastInfo = (msg) => {
  return toast.info(msg, {
    position: toast.POSITION.BOTTOM_CENTER,
  })
}

export const defaultDateDisplayUnix = (date, withTime = false) => {
  const format = withTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"
  return moment.unix(date).utc().local().format(format)
}

export const defaultDateInputDisplay = (date, withTime = false) => {
  const format = withTime ? "YYYY-MM-DDTHH:mm" : "YYYY-MM-DD"
  const convertToLocalDate = moment(date).utc().local().format(format)
  // console.log("convertToLocalDate", convertToLocalDate);
  // console.log("date.slice(0, 10)", date.slice(0, 10));
  // console.log("date.slice(0, 16)", date.slice(0, 16));

  return convertToLocalDate
}

export const cantNullEmptyAndUndefined = (str) => {
  if (str !== "" && str !== undefined && str !== null) {
    return true
  } else {
    return false
  }
}

export const scrollToTop = () => {
  return window.scrollTo({
    top: 0,
    behavior: "smooth",
  })
}

export const formatRupiah = (angka) => {
  if (isNull(angka)) {
    return ""
  } else {
    // let number_string = angka
    //   .toString()
    //   .replace(/[^,\d]/g, "")
    //   .toString();
    // const split = number_string.split(",");
    // const sisa = split[0].length % 3;
    // let rupiah = split[0].substr(0, sisa);
    // let ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    // if (ribuan) {
    //   let separator = sisa ? "." : "";
    //   rupiah += separator + ribuan.join(".");
    // }

    // if (split.length > 1) {
    //   if (split[1].length <= 2) {
    //     rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
    //     return rupiah;
    //   } else {
    //     rupiah =
    //       split[1] !== undefined
    //         ? rupiah + "," + split[1].substring(0, 2)
    //         : rupiah;
    //     return rupiah;
    //   }
    // } else {
    //   return rupiah;
    // }

    let number_string = angka
      .toString()
      .replace(/[^.\d]/g, "")
      .toString()

    const split = number_string.split(".")

    const sisa = split[0].length % 3
    let rupiah = split[0].substr(0, sisa)
    let ribuan = split[0].substr(sisa).match(/\d{3}/gi)

    if (ribuan) {
      let separator = sisa ? "," : ""
      rupiah += separator + ribuan.join(",")
    }

    if (split.length > 1) {
      if (split[1].length <= 2) {
        rupiah = split[1] !== undefined ? rupiah + "." + split[1] : rupiah
        return rupiah
      } else {
        rupiah =
          split[1] !== undefined
            ? rupiah + "." + split[1].substring(0, 2)
            : rupiah
        return rupiah
      }
    } else {
      return rupiah
    }
  }
}

export const removePoint = (str) => {
  if (!isNull(str)) {
    const newStr = str.replaceAll(".", "")
    return newStr
  } else {
    return str
  }
}

export const removeKoma = (str) => {
  if (!isNull(str)) {
    const newStr = str === 0 ? 0 : str.toString().replaceAll(",", "")
    return newStr
  } else {
    return str
  }
}

export const oneMonthBeforeToday = (withTime = false) => {
  if (withTime) {
    return moment(
      moment().local().format("YYYY-MM-DDTHH:mm"),
      "YYYY-MM-DDTHH:mm",
    )
      .subtract(1, "months")
      .format("YYYY-MM-DDTHH:mm")
  } else {
    return moment(moment().local().format("YYYY-MM-DD"), "YYYY-MM-DD")
      .subtract(1, "months")
      .format("YYYY-MM-DD")
  }
}

export const oneMonthAfterToday = (withTime = false) => {
  if (withTime) {
    return moment(
      moment().local().format("YYYY-MM-DDTHH:mm"),
      "YYYY-MM-DDTHH:mm",
    )
      .add(1, "months")
      .format("YYYY-MM-DDTHH:mm")
  } else {
    return moment(moment().local().format("YYYY-MM-DD"), "YYYY-MM-DD")
      .add(1, "months")
      .format("YYYY-MM-DD")
  }
}

export const ToOneMonthAfterToday = (date, withTime = false) => {
  if (withTime) {
    return moment(
      moment(date).local().format("YYYY-MM-DDTHH:mm"),
      "YYYY-MM-DDTHH:mm",
    )
      .add(1, "months")
      .format("YYYY-MM-DDTHH:mm")
  } else {
    return moment(moment(date).local().format("YYYY-MM-DD"), "YYYY-MM-DD")
      .add(1, "months")
      .format("YYYY-MM-DD")
  }
}

export const monthBeforeToday = (month = 1, withTime = false) => {
  if (withTime) {
    return moment(
      moment().local().format("YYYY-MM-DDTHH:mm"),
      "YYYY-MM-DDTHH:mm",
    )
      .subtract(month, "months")
      .format("YYYY-MM-DDTHH:mm")
  } else {
    return moment(moment().local().format("YYYY-MM-DD"), "YYYY-MM-DD")
      .subtract(month, "months")
      .format("YYYY-MM-DD")
  }
}

export const validPriceTanpaPembulatan = (str) => {
  if (!isNull(str)) {
    const hapusKoma = removeKoma(str)
    const changeKomaToTitik =
      hapusKoma === 0 ? hapusKoma : hapusKoma.replaceAll(",", ".")
    return +parseFloat(changeKomaToTitik).toFixed(2)
  } else {
    return 0
  }
}

export const convertToValidPrice = (str, withToFixed = true) => {
  if (!isNull(str)) {
    const hapusKoma = removeKoma(str)
    const changeKomaToTitik =
      hapusKoma === 0 ? hapusKoma : hapusKoma.replaceAll(",", ".")
    if (withToFixed) {
      return +parseFloat(changeKomaToTitik).toFixed(2)
    } else {
      return +parseFloat(changeKomaToTitik)
    }
  } else {
    return 0
  }
}

export function formatNumber(number, withToFixed = true) {
  if (isNull(number)) {
    return "0"
  } else {
    const thousand = new Intl.NumberFormat("en-US")
    return thousand.format(
      typeof number === "number" ? withToFixed ? number.toFixed(2) : number : number,
    )
  }
}

export function nl2br(str, is_xhtml) {
  if (typeof str === "undefined" || str === null) {
    return ""
  }
  let breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "" : "\n"
  return (str + "").replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    "$1" + breakTag + "$2",
  )
}

export const fetchData = async (
  type,
  url,
  data = "body",
  options = {},
  subData = undefined,
) => {
  try {
    if (type === TYPE_INSTANCE1) {
      const api = await instance1.get(url, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE2) {
      const api = await instance2.get(url, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE3) {
      const api = await instance3.get(url, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE4) {
      const api = await instance4.get(url, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE5) {
      const api = await instance5.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_SATU_SEHAT) {
      const api = await instanceSatuSehat.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCEVCLAIM) {
      const api = await instanceVclaim.get(url, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_WS_BPJS_LIST_DOKTER) {
      const api = await instanceWsBPJS.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE_MASTER_EMR) {
      const api = await instancePublicMasterEMR.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE_MASTER_EMR2) {
      const api = await instancePublicMasterEMRV2.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE_REGISTRASI_EMR_V3) {
      const api = await instanceRegistrasiEMRV3.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE_HRIS) {
      const api = await instanceHRIS.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_SATU_SEHAT_V2) {
      const api = await instanceSatuSehatV2.get(url, options)
      const res = api.data

      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    }
  } catch (error) {
    console.log("error", error)
    defaultToastError(error?.response?.data?.message)
    return false
  }
}

export const fetchDataPut = async (
  type,
  url,
  data = "body",
  body = {},
  options = {},
  subData = undefined,
) => {
  try {
    if (type === TYPE_SATU_SEHAT) {
      const api = await instanceSatuSehat.put(url, body)
      return api
    }
  } catch (error) {
    defaultToastError(error?.response?.data?.message)
    return false
  }
}

export const fetchDataPost = async (
  type,
  url,
  data = "body",
  body = {},
  options = {},
  subData = undefined,
) => {
  try {
    if (type === TYPE_INSTANCE1) {
      const api = await instance1.post(url, body, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE2) {
      const api = await instance2.post(url, body, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE3) {
      const api = await instance3.post(url, body, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE4) {
      const api = await instance4.post(url, body, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE5) {
      const api = await instance5.post(url, body, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCEVCLAIM) {
      const api = await instanceVclaim.post(url, body, options)
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCEAPPLICARES) {
      const api = await instanceApplicares.post(url, body, options)
      // console.log(api, "api");
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE_MASTER_EMR) {
      const api = await instancePublicMasterEMR.post(url, body, options)
      // console.log(api, "api");
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    } else if (type === TYPE_INSTANCE_HRIS) {
      const api = await instanceHRIS.post(url, body, options)
      // console.log(api, "api");
      const res = api.data
      if (data === "data" && subData === undefined) {
        if (api.meta_data.status === 200) {
          return res.data
        } else {
          return false
        }
      } else if (subData !== undefined) {
        return res[data][subData]
      } else {
        return res[data]
      }
    }
  } catch (error) {
    console.log("error", error)
    defaultToastError(error?.response?.data?.message)
    return false
  }
}

export const titleModal = (id) => {
  return id === "" ? "Tambah" : "Ubah"
}

export function capitalizeFirst(string) {
  if (!isNull(string)) {
    const arr = string.split(" ")
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase()
    }
    const str2 = arr.join(" ")
    return str2
  } else {
    return string
  }
}

export function toDayIndo(day) {
  if (isNull(day)) {
    return "tidak ditemukan"
  } else {
    let hari
    const day2 = day.toLowerCase()
    switch (day2) {
      case "monday":
        hari = "Senin"
        break
      case "tuesday":
        hari = "Selasa"
        break
      case "wednesday":
        hari = "Rabu"
        break
      case "thursday":
        hari = "Kamis"
        break
      case "friday":
        hari = "Jumat"
        break
      case "saturday":
        hari = "Sabtu"
        break
      case "sunday":
        hari = "Minggu"
        break
      default:
        hari = "wrong day"
        break
    }

    return hari
  }
}

export const changeHandlerLocalStorageForm = (
  text,
  e,
  formData,
  setFormData,
  item,
) => {
  localStorage.setItem(
    item,
    JSON.stringify({
      ...formData,
      [text]: e.target.value,
    }),
  )
  setFormData({
    ...formData,
    [text]: e.target.value,
  })
}

export const changeHandlerLocalStorageFormUnit = (
  text,
  e,
  formData,
  setFormData,
  item,
) => {
  localStorage.setItem(
    item,
    JSON.stringify({
      ...formData,
      [text]: e.value.split,
    }),
  )
  setFormData({
    ...formData,
    [text]: e.value.split,
  })
}

export const setLocalStorageAsFormData = (setFormData, item) => {
  const formLocal = localStorage.getItem(item)
  if (formLocal) {
    setFormData({
      ...JSON.parse(formLocal),
    })
  }
}

export const setFormDataAsLocalStorage = (formData, item) => {
  return localStorage.setItem(item, JSON.stringify(formData))
}

export const removeLocalStorageAsFormData = (item) => {
  const formLocal = localStorage.getItem(item)
  if (formLocal) {
    localStorage.removeItem(item)
  }
}

export const getAccessUser = async (access_code) => {
  try {
    const response = await instance2.get("/users_access/get_accessusers", {
      headers: {
        access_code,
      },
    })

    if (response.data.status === 200) {
      return {
        state: true,
        data: [response.data.table_id],
      }
    } else {
      return {
        state: false,
        data: [],
      }
    }
  } catch (error) {
    return {
      state: false,
      data: [],
    }
  }
}

export function pembilang(nilai) {
  nilai = Math.abs(nilai)
  var simpanNilaiBagi = 0
  var huruf = [
    "",
    "Satu",
    "Dua",
    "Tiga",
    "Empat",
    "Lima",
    "Enam",
    "Tujuh",
    "Delapan",
    "Sembilan",
    "Sepuluh",
    "Sebelas",
  ]
  var temp = ""

  if (nilai < 12) {
    temp = " " + huruf[nilai]
  } else if (nilai < 20) {
    temp = pembilang(nilai - 10) + " Belas"
  } else if (nilai < 100) {
    simpanNilaiBagi = Math.floor(nilai / 10)
    temp = pembilang(simpanNilaiBagi) + " Puluh" + pembilang(nilai % 10)
  } else if (nilai < 200) {
    temp = " Seratus" + pembilang(nilai - 100)
  } else if (nilai < 1000) {
    simpanNilaiBagi = Math.floor(nilai / 100)
    temp = pembilang(simpanNilaiBagi) + " Ratus" + pembilang(nilai % 100)
  } else if (nilai < 2000) {
    temp = " Seribu" + pembilang(nilai - 1000)
  } else if (nilai < 1000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000)
    temp = pembilang(simpanNilaiBagi) + " Ribu" + pembilang(nilai % 1000)
  } else if (nilai < 1000000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000000)
    temp = pembilang(simpanNilaiBagi) + " Juta" + pembilang(nilai % 1000000)
  } else if (nilai < 1000000000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000000000)
    temp =
      pembilang(simpanNilaiBagi) + " Miliar" + pembilang(nilai % 1000000000)
  } else if (nilai < 1000000000000000) {
    simpanNilaiBagi = Math.floor(nilai / 1000000000000)
    temp =
      pembilang(nilai / 1000000000000) +
      " Triliun" +
      pembilang(nilai % 1000000000000)
  }

  return temp
}

export function onlyNumber(str) {
  const number = str
    .replace(/[^.\d]/g, "")
    .replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2")
  // const result = parseFloat(number);
  return isNaN(number) ? 0 : number
}

export const getDifferentObjects = (array1, array2) => {
  const differentObjects = []

  array1.forEach((obj1) => {
    let found = false
    array2.forEach((obj2) => {
      if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
        found = true
      }
    })
    if (!found) {
      differentObjects.push(obj1)
    }
  })

  array2.forEach((obj2) => {
    let found = false
    array1.forEach((obj1) => {
      if (JSON.stringify(obj2) === JSON.stringify(obj1)) {
        found = true
      }
    })
    if (!found) {
      differentObjects.push(obj2)
    }
  })

  return differentObjects
}

export function validateHoursFormat(time) {
  // Regular expression pattern for matching time in the format HH:MM or H:MM
  var pattern = /^([01]\d|2[0-3]):([0-5]\d)$/

  // Test the time against the pattern
  return pattern.test(time)
}

export const valueChecker = (id, name) => {
  if (!isNull(id)) {
    if (id !== "xx") {
      if (id.toString().trim() !== name.toString().trim()) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
}

export const getCode = (id, name) => {
  try {
    if (valueChecker(id, name)) {
      const splitDiagnosa = name.split("-")
      const kode = splitDiagnosa[0].trim()
      return kode
    } else {
      return ""
    }
  } catch (err) {
    return "xx"
  }
}

export function base64ToBlob(base64, mimeType) {
  try {
    const byteCharacters = atob(base64)
    const byteArrays = []
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512)
      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }
    return new Blob(byteArrays, { type: mimeType })
  } catch (err) {
    console.log("~ base64ToBlob ~ err:", err);
  }
}

export function base64ToBlobV2(base64, mimeType) {
  try {
    // Decode base64 string to raw binary data held in a string
    const binaryString = atob(base64);

    // Convert binary string to Uint8Array directly using TextEncoder
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create a blob with the specified MIME type
    return new Blob([bytes], { type: mimeType });
  } catch (err) {
    console.error("~ base64ToBlob ~ Error:", err);
  }
}

export const durasiWaktu = (waktu) => {
  if (waktu > 0) {
    const days = parseInt(waktu.asDays())
    let hours = parseInt(waktu.asHours())
    hours = hours - days * 24
    let minutes = parseInt(waktu.asMinutes())
    minutes = minutes - (days * 24 * 60 + hours * 60)

    return days + " Hari, " + hours + " Jam, " + minutes + " Menit"
  } else {
    return "0 Menit"
  }
}

export const parseWaktu = (timestamp) => {
  // Buat objek Date dari timestamp
  const waktuTerkini = new Date()
  const waktuTimestamp = new Date(timestamp)

  // Hitung selisih waktu dalam milidetik
  const selisih = waktuTerkini - waktuTimestamp
  if (selisih < 0) {
    return "waktu habis"
  }

  // Konversi selisih waktu menjadi hari, jam, menit, dan detik
  const detik = Math.floor(selisih / 1000)
  const menit = Math.floor(detik / 60)
  const jam = Math.floor(menit / 60)
  const hari = Math.floor(jam / 24)

  return `${hari} hari, ${jam % 24} jam, ${menit % 60} menit, ${detik % 60
    } detik`
}

function generateKey(obj, properties) {
  return properties.map((property) => obj[property]).join("|")
}

/**
 *
 * @param {*} array Data Arry yang mau di hilangkan duplikasinya
 * @param {*} properties KEY dari array object yang dipilih untuk jadi patokan pemeriksaan ['id', 'name'], jika diabaikan secara default seluruh key akan diperiksa
 * @returns
 */
export function removeDuplicates(array, properties = []) {
  if (properties.length === 0) {
    const uniqueArray = array.filter(
      (object, index, self) =>
        index ===
        self.findIndex((o) => JSON.stringify(o) === JSON.stringify(object)),
    )
    return uniqueArray
  } else {
    const uniqueValues = new Set()
    const uniqueArray = array.reduce((result, obj) => {
      const key = generateKey(obj, properties)
      if (!uniqueValues.has(key)) {
        uniqueValues.add(key)
        result.push(obj)
      }
      return result
    }, [])
    return uniqueArray
  }
}

export const upper = (str) => {
  if (isNull(str)) {
    return ""
  } else {
    return str?.toUpperCase()
  }
}

export const fixUTCFormat = (utcString) => {
  // 2023-10-06T18:00:00.000Z
  const utcPattern =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d{3}))?Z$/
  // 2023-10-06T18:00:00.00Z
  const utcPattern2 =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d{2}))?Z$/
  // 2023-10-06T18:00:00+00:00
  const utcPattern3 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/

  if (utcPattern.test(utcString)) {
    return utcString
  } else if (utcPattern2.test(utcString)) {
    return utcString
  } else if (utcPattern3.test(utcString)) {
    return utcString
  } else {
    const utcNoPrefixPattern =
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))$/
    if (utcNoPrefixPattern.test(utcString)) {
      return `${utcString}.000Z`
    } else {
      return moment(utcString).utc(false).format()
    }
  }
}

export function getLastSlinceString(filename = "", separator = "") {
  var parts = filename.split(separator)
  if (parts.length === 1) {
    return filename ?? "" // If the filename doesn't have an extension
  }
  return parts[parts.length - 1] // Return the last part as the file extension
}

export const statusSucess = (status) => {
  if (status === 200 || status === 201) {
    return true
  } else {
    return false
  }
}

export const isValidString = (input) => {
  // Periksa apakah input adalah string
  return typeof input === "string" || input instanceof String
}

export const generateRandomNumber = (length) => {
  let randomNumber = ""
  for (let i = 0; i < length; i++) {
    randomNumber += Math.floor(Math.random() * 10) // Generate random digit (0-9)
  }
  return parseInt(randomNumber)
}

export const checkBlobIsJSON = (blob) => {
  return blob.text().then(text => {
    try {
      const data = JSON.parse(text);
      return { state: true, data: data };
    } catch (e) {
      return { state: false, data: "" };
    }
  });
};

export function isJSON(data) {
  try {
    JSON.parse(data);
    return true;
  } catch (e) {
    return false;
  }
}


export const splitPath = (path) => {
  try {
    const pathSplit = path.split("\\");
    return pathSplit;
  } catch (e) {
    console.log(e)
    return [];
  }
}

export const optionCaraMasuk = [
  {
    value: 'gp',
    label: 'Rujukan FKTP'
  },
  {
    value: 'hosp-trans',
    label: 'Rujukan FKRTL'
  },
  {
    value: 'mp',
    label: 'Rujukan Spesialis'
  },
  {
    value: 'outp',
    label: 'Dari Rawat Jalan'
  },
  {
    value: 'inp',
    label: 'Dari Rawat Inap'
  },
  {
    value: 'emd',
    label: 'Dari Rawat Darurat'
  },
  {
    value: 'born',
    label: 'Lahir di RS'
  },
  {
    value: 'nursing',
    label: 'Rujukan Panti Jompo'
  },
  {
    value: 'psych',
    label: 'Rujukan dari RS Jiwa'
  },
  {
    value: 'rehab',
    label: 'Rujukan Fasilitas Rehab'
  },
  {
    value: 'other',
    label: 'Lain-lain'
  },
]

export const optionPenanggungNaikKelas = [
  {
    value: 'peserta',
    label: 'Peserta'
  },
  {
    value: 'pemberi_kerja',
    label: 'Pemberi Kerja'
  },
  {
    value: 'asuransi_tambahan',
    label: 'Asuransi Tambahan'
  }
]